module.exports = __webpack_public_path__ + "static/media/login-background-img.c5dc15bd.png";